export default function EmptyInspectorIcon() {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* person silhouette */}
      <circle
        cx="28"
        cy="20"
        r="9"
        fill="currentColor"
        opacity="0.1"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M10 50c0-10 8-16 18-16s18 6 18 16"
        fill="currentColor"
        opacity="0.1"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      {/* clipboard */}
      <rect
        x="30"
        y="30"
        width="22"
        height="26"
        rx="2"
        fill="currentColor"
        opacity="0.08"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <rect
        x="35"
        y="27"
        width="12"
        height="5"
        rx="1.5"
        fill="currentColor"
        opacity="0.2"
        stroke="currentColor"
        strokeWidth="1.3"
      />
      {/* checklist lines */}
      <line x1="35" y1="38" x2="46" y2="38" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" opacity="0.6" />
      <line x1="35" y1="43" x2="46" y2="43" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" opacity="0.6" />
      <line x1="35" y1="48" x2="41" y2="48" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" opacity="0.6" />
      {/* no-entry badge */}
      <circle cx="50" cy="50" r="10" fill="var(--bg2, #fff)" stroke="currentColor" strokeWidth="1.8" />
      <line x1="45" y1="50" x2="55" y2="50" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );
}
